﻿(function() {
  "use strict";

  angular.module("app").controller("AttachmentsController", AttachmentsController);

  AttachmentsController.$inject = ['$stateParams', "constants", "$location"];

  function AttachmentsController($stateParams, constants, $location) {
    var vm = this;
    vm.$onInit = onInit;
    vm.previousRoute = "";

    function onInit() {
      vm.previousRoute = $location.search().backUrl || constants.previousRouteAttachments;
      var url = location.hash, id;

      if (url.includes('/properties/')) {
        id = $stateParams.propertyId
      } else {
        id = $stateParams.id;
        vm.previousRoute = "#!/customers#" + $stateParams.id;
      }

      id = id.match(/^\d+/)[0];
      vm.customerId = $stateParams.id
      vm.propertyId = $stateParams.propertyId

      vm.initialFolder = $location.hash()
    }
  }

})();
